export default {"src":"/_next/static/media/mencia.9ba74a8a.svg","height":120,"width":403,"blurWidth":0,"blurHeight":0};